import React from 'react';
import { Alert } from '@meddihub/ui';
import { MzcrCertificateSettings } from '@meddihub/mzcr-ui';
import { getMzcrClient } from '../Services/mzcrClient';
import { useAppContext } from '../../../Services/AppContext';
import useRefreshMzcrAcl from '../Services/useRefreshMzcrAcl';
import useMzcrLocale from '../Services/useMzcrLocale';
import useTranslation from '../../../Hooks/useTranslation';
import ScrollContainer from '../../Base/Components/ScrollContainer';

interface Props {
	workplaceId: string;
}

// Certifikát MZČR patří pracovišti, za které je uživatel přihlášený – user-api /mzcr nepřijímá jiné workplaceId
const MzcrWorkplaceSettingsWrapper: React.FC<Props> = ({ workplaceId }) => {
	const { t } = useTranslation();
	const appContext = useAppContext();
	const refreshMzcrAcl = useRefreshMzcrAcl();
	const locale = useMzcrLocale();

	if (workplaceId !== appContext.workplaceId) {
		return (
			<Alert tone='info'>
				{t('component.mzcr.workplaceSettings.otherWorkplace')}
			</Alert>
		);
	}

	// The settings tab has a fixed height - the certificate form scrolls inside it
	return (
		<ScrollContainer>
			<MzcrCertificateSettings
				mzcrClient={getMzcrClient()}
				onCertificateUploaded={refreshMzcrAcl}
				locale={locale}
			/>
		</ScrollContainer>
	);
};

export default MzcrWorkplaceSettingsWrapper;
